import { MessageCircle } from "lucide-react";
import { BRAND } from "../lib/constants";
import { useTranslation } from "../lib/i18n";

export const WhatsAppWidget = () => {
  const { t } = useTranslation();
  return (
    <a
      href={`${BRAND.whatsappUrl}?text=${encodeURIComponent(
        "Hello Beyond Borders Travel — I'd like to enquire about your services."
      )}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-widget"
      aria-label={t("wa.aria")}
      className="group fixed bottom-6 right-6 z-40 flex items-center gap-3"
    >
      <span className="hidden sm:inline-block bg-[#0B1120]/90 backdrop-blur-md border border-white/10 text-white/85 text-xs uppercase tracking-[0.2em] px-4 py-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
        {t("wa.tooltip")}
      </span>
      <span className="relative grid place-items-center h-14 w-14 rounded-full bg-gold text-gold-ink shadow-[0_8px_30px_rgba(212,175,55,0.45)] animate-pulse-gold">
        <MessageCircle className="h-6 w-6" strokeWidth={2} />
      </span>
    </a>
  );
};

export default WhatsAppWidget;
